export default __webpack_public_path__ + "static/media/oueBayFront.jpg?.1dc73629";